import { toPhpLangId } from '@ifixit/i18n/php-langid';
import { parseUserLocale, type UserLocaleCode } from '@ifixit/i18n/user-locale';
import { LocationProvider as SharedLocationProvider } from '@ifixit/ui/components/location-provider';
import { type ReactNode } from 'react';

interface LocationProviderProps {
   children: ReactNode;
   langLinks: Record<string, string>;
}

export function LocationProvider({ children, langLinks }: LocationProviderProps) {
   return (
      <SharedLocationProvider
         currentPhpLangId={App.lang}
         hrefFromUserLocale={hrefFromUserLocale}
         isCarpenter
         withProgressBar={(callback: () => Promise<void>) => callback()}
      >
         {children}
      </SharedLocationProvider>
   );

   function hrefFromUserLocale(userLocaleCode: UserLocaleCode) {
      const { language } = parseUserLocale(userLocaleCode);
      const phpLangId = toPhpLangId(language);
      return langLinks[phpLangId];
   }
}
